// extracted by css-extract-rspack-plugin
export default {"cls1":"TextArea-cls1__BU","cls2":"TextArea-cls2_4Gp TextArea-cls1__BU"};